import {handleResponse, authHeader} from '../helpers';

const BASE_URL = process.env.REACT_APP_API_URL;

export const productSearchOverrideService = {
    getProductsByType,
    getOverridesByPortal,
    saveOverride,
    deleteOverride,
};

function getProductsByType(type, portal) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}/product-search/products/${type}?portal=${portal}`, requestOptions)
        .then(handleResponse)
        .then(response => response);
}

function getOverridesByPortal(portal) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}/product-search/overrides/${portal}`, requestOptions)
        .then(handleResponse)
        .then(response => response);
}

function saveOverride(externalId, portal, searchTerm) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({
            external_id: externalId,
            portal: portal,
            search_term: searchTerm,
        }),
    };

    return fetch(`${BASE_URL}/product-search/override`, requestOptions)
        .then(handleResponse)
        .then(response => response);
}

function deleteOverride(externalId, portal) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}/product-search/override/${externalId}/${portal}`, requestOptions)
        .then(handleResponse)
        .then(response => response);
}
